import script from "./ModalShare.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalShare.vue?vue&type=script&setup=true&lang=js"

import "./ModalShare.vue?vue&type=style&index=0&id=4b56d32c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b56d32c"]])

export default __exports__